import { LoadingPage } from "../../../../shared/components/LoadingPage";
import { TableInfo } from "../../../../shared/components/Table";
import { useGetEstoqueContato } from "../../hooks/useGetEstoqueContato";
import { columnsEstoque } from "../../utils/columnsEstoque";
interface EstoqueContatoProps {
  ContatoId: number;
}

export function EstoqueContato({ ContatoId }: EstoqueContatoProps) {
  const { data: EstoqueContato, isLoading } = useGetEstoqueContato(ContatoId);
  const EstoqueContatoData = EstoqueContato?.map((estoque: any, index: number) => ({
    key: index,
    ...estoque,
  }));

  return (
    <div className="w-[70rem] h-[30rem] overflow-hidden overflow-y-auto">
      {isLoading ? <div className="h-[30rem] flex items-center justify-center"><LoadingPage /></div>  :
        <TableInfo
          dataSource={EstoqueContatoData}
          columns={columnsEstoque}
        />
      }
    </div>
  );
}
